/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiChatCompletion,
  AiChatCompletionRequestInput,
  PaginatedAiChatCompletions,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Chat Completion
 */
export const createAiChatCompletion = (
    aiChatCompletionRequestInput: MaybeRefOrGetter<AiChatCompletionRequestInput>,
 signal?: AbortSignal
) => {
      aiChatCompletionRequestInput = toValue(aiChatCompletionRequestInput);

      return axiosClient<AiChatCompletion>(
      {url: `/ai/chat_completions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiChatCompletionRequestInput, signal
    },
      );
    }




export const getCreateAiChatCompletionMutationKey = () => ['createAiChatCompletion'] as const;

export const getCreateAiChatCompletionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiChatCompletion>>, TError,CreateAiChatCompletionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAiChatCompletion>>, TError,CreateAiChatCompletionMutationVariables, TContext> => {

const mutationKey = getCreateAiChatCompletionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAiChatCompletion>>, CreateAiChatCompletionMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createAiChatCompletion(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAiChatCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof createAiChatCompletion>>>
    export type CreateAiChatCompletionMutationBody = AiChatCompletionRequestInput
    export type CreateAiChatCompletionMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateAiChatCompletionMutationVariables = {data: AiChatCompletionRequestInput}

    /**
 * @summary Create AI Chat Completion
 */
export const useCreateAiChatCompletion = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAiChatCompletion>>, TError,CreateAiChatCompletionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAiChatCompletion>>,
        TError,
        CreateAiChatCompletionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAiChatCompletionMutationOptions(options), queryClient);
    }
    /**
 * @summary List of AI Chat Completions
 */
export const listAiChatCompletions = (

 signal?: AbortSignal
) => {


      return axiosClient<PaginatedAiChatCompletions>(
      {url: `/ai/chat_completions`, method: 'GET', signal
    },
      );
    }




export const getListAiChatCompletionsQueryKey = () => {
    return [
    'ai','chat_completions'
    ] as const;
    }


export const getListAiChatCompletionsQueryOptions = <TData = Awaited<ReturnType<typeof listAiChatCompletions>>, TError = ErrorType<void>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiChatCompletions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getListAiChatCompletionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAiChatCompletions>>> = ({ signal }) => listAiChatCompletions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAiChatCompletions>>, TError, TData>
}

export type ListAiChatCompletionsQueryResult = NonNullable<Awaited<ReturnType<typeof listAiChatCompletions>>>
export type ListAiChatCompletionsQueryError = ErrorType<void>


/**
 * @summary List of AI Chat Completions
 */

export function useListAiChatCompletions<TData = Awaited<ReturnType<typeof listAiChatCompletions>>, TError = ErrorType<void>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAiChatCompletions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListAiChatCompletionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete AI Chat Completion
 */
export const deleteAiChatCompletion = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/chat_completions/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAiChatCompletionMutationKey = () => ['deleteAiChatCompletion'] as const;

export const getDeleteAiChatCompletionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiChatCompletion>>, TError,DeleteAiChatCompletionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAiChatCompletion>>, TError,DeleteAiChatCompletionMutationVariables, TContext> => {

const mutationKey = getDeleteAiChatCompletionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAiChatCompletion>>, DeleteAiChatCompletionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  deleteAiChatCompletion(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAiChatCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAiChatCompletion>>>

    export type DeleteAiChatCompletionMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAiChatCompletionMutationVariables = {id: string}

    /**
 * @summary Delete AI Chat Completion
 */
export const useDeleteAiChatCompletion = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAiChatCompletion>>, TError,DeleteAiChatCompletionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAiChatCompletion>>,
        TError,
        DeleteAiChatCompletionMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAiChatCompletionMutationOptions(options), queryClient);
    }
    /**
 * @summary AI Chat Completion Details
 */
export const getAiChatCompletion = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<AiChatCompletion>(
      {url: `/ai/chat_completions/${id}`, method: 'GET', signal
    },
      );
    }




export const getGetAiChatCompletionQueryKey = (id: MaybeRefOrGetter<string>,) => {
    return [
    'ai','chat_completions',id
    ] as const;
    }


export const getGetAiChatCompletionQueryOptions = <TData = Awaited<ReturnType<typeof getAiChatCompletion>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiChatCompletion>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getGetAiChatCompletionQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAiChatCompletion>>> = ({ signal }) => getAiChatCompletion(id, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(id) !== null && toValue(id) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAiChatCompletion>>, TError, TData>
}

export type GetAiChatCompletionQueryResult = NonNullable<Awaited<ReturnType<typeof getAiChatCompletion>>>
export type GetAiChatCompletionQueryError = ErrorType<SchemaValidationErrorResponse | void>


/**
 * @summary AI Chat Completion Details
 */

export function useGetAiChatCompletion<TData = Awaited<ReturnType<typeof getAiChatCompletion>>, TError = ErrorType<SchemaValidationErrorResponse | void>>(
 id: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAiChatCompletion>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAiChatCompletionQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update AI Chat Completion
 */
export const updateAiChatCompletion = (
    id: MaybeRefOrGetter<string>,
    aiChatCompletionRequestInput: MaybeRefOrGetter<AiChatCompletionRequestInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
aiChatCompletionRequestInput = toValue(aiChatCompletionRequestInput);

      return axiosClient<AiChatCompletion>(
      {url: `/ai/chat_completions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: aiChatCompletionRequestInput, signal
    },
      );
    }




export const getUpdateAiChatCompletionMutationKey = () => ['updateAiChatCompletion'] as const;

export const getUpdateAiChatCompletionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiChatCompletion>>, TError,UpdateAiChatCompletionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAiChatCompletion>>, TError,UpdateAiChatCompletionMutationVariables, TContext> => {

const mutationKey = getUpdateAiChatCompletionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAiChatCompletion>>, UpdateAiChatCompletionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateAiChatCompletion(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAiChatCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof updateAiChatCompletion>>>
    export type UpdateAiChatCompletionMutationBody = AiChatCompletionRequestInput
    export type UpdateAiChatCompletionMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateAiChatCompletionMutationVariables = {id: string;data: AiChatCompletionRequestInput}

    /**
 * @summary Update AI Chat Completion
 */
export const useUpdateAiChatCompletion = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAiChatCompletion>>, TError,UpdateAiChatCompletionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAiChatCompletion>>,
        TError,
        UpdateAiChatCompletionMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAiChatCompletionMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel AI Chat Completion
 */
export const cancelAiChatCompletion = (
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/chat_completions/${id}/cancel`, method: 'PUT', signal
    },
      );
    }




export const getCancelAiChatCompletionMutationKey = () => ['cancelAiChatCompletion'] as const;

export const getCancelAiChatCompletionMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiChatCompletion>>, TError,CancelAiChatCompletionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelAiChatCompletion>>, TError,CancelAiChatCompletionMutationVariables, TContext> => {

const mutationKey = getCancelAiChatCompletionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelAiChatCompletion>>, CancelAiChatCompletionMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  cancelAiChatCompletion(id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelAiChatCompletionMutationResult = NonNullable<Awaited<ReturnType<typeof cancelAiChatCompletion>>>

    export type CancelAiChatCompletionMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type CancelAiChatCompletionMutationVariables = {id: string}

    /**
 * @summary Cancel AI Chat Completion
 */
export const useCancelAiChatCompletion = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelAiChatCompletion>>, TError,CancelAiChatCompletionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelAiChatCompletion>>,
        TError,
        CancelAiChatCompletionMutationVariables,
        TContext
      > => {
      return useMutation(getCancelAiChatCompletionMutationOptions(options), queryClient);
    }
